import { unref } from 'vue'
import { webApi } from '../webApi.js'
import { authStorage } from '../http.js'
import { useAppContext } from '../../composables/appContext.js'

// 只持久化恢复请求所需的编号；资格、金额及参与结果始终读取服务端。
export const activityStorage = {
  get(key) { const value = localStorage.getItem(`web:${key}`); return value === null ? '' : JSON.parse(value) },
  set(key, value) { localStorage.setItem(`web:${key}`, JSON.stringify(value)) },
  remove(key) { localStorage.removeItem(`web:${key}`) }
}
export const activityLock = typeof navigator !== 'undefined' && navigator.locks
  ? (key, work) => navigator.locks.request(`web:${key}`, { ifAvailable: true }, lock => work(Boolean(lock))) : undefined

export const gameplayApi = {
  pageBackflowState: id => webApi.pageBackflowState(id), pageBackflowClaim: (id, body) => webApi.pageBackflowClaim(id, body),
  euroTopState: id => webApi.euroTopState(id), euroTopClaim: (id, body) => webApi.euroTopClaim(id, body),
  euroQuizState: id => webApi.euroQuizState(id), euroQuizAction: (id, body) => webApi.euroQuizAction(id, body),
  state: id => webApi.gameplayState(id), action: (id, body) => webApi.gameplayAction(id, body),
  recover: (id, uuid) => webApi.gameplayRequest(id, uuid),
  newbiePackage: id => webApi.newbiePackage(id),
  firstDeposit: (id, query) => query ? webApi.firstDepositState(id, query) : webApi.firstDepositState(id),
  firstDepositOriginal: id => webApi.firstDepositOriginal(id),
  firstDepositPreview: (id, body) => webApi.firstDepositPreview(id, body),
  firstDepositApplication: (id, body) => webApi.firstDepositApplication(id, body),
  firstDepositApplicationResult: (id, uuid) => webApi.firstDepositApplicationResult(id, uuid),
  voteResult: (id, uuid) => webApi.voteResult(id, uuid), voteRecords: (id, body) => webApi.voteRecords(id, body)
}
export const prizeOrderApi = { apply: (id, body) => webApi.applyActivityPrize(id, body) }

export function useWebActivity() {
  const context = useAppContext()
  const getAuth = () => ({ memberId: unref(context.memberDashboard)?.memberId || unref(context.memberProfile)?.id || '' })
  function go(url) {
    if (url?.startsWith('/pages/game/index?')) {
      const params = new URLSearchParams(url.slice('/pages/game/index?'.length))
      const venueId = params.get('venueId') || ''
      if (/^[1-9]\d*$/.test(venueId)) return context.navigate(`/game/venue/${venueId}?venueName=${encodeURIComponent(params.get('venueName') || '')}`)
      return
    }
    const routes = { '/pages/index/index': '/', '/pages/profile/index': '/member', '/pages/bind-phone/index': '/member', '/pages/account/index': '/mine/finance/wallet', '/pages/deposit/index': '/mine/finance/deposit' }
    context.navigate(routes[url] || '/mine/record/giftRecord')
  }
  return { ...context, getAuth, getToken: authStorage.getToken, go, storage: activityStorage }
}
